import { Component, OnInit } from "@angular/core";

import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";

@Component({
    selector: "app-datepicker",
    templateUrl: "./datepicker.component.html",
    styleUrls: ["./datepicker.component.scss"],
    standalone: false
})
export class DatePickerComponent extends BaseControlComponent implements OnInit {
    static componentName = "DatePickerComponent";

	dateModel?: Date;
    placeholder: string = "mm/dd/yyyy";

    get maxDaysPast(): number | undefined {
        return this.componentData?.config?.maxDaysPast;
    }

    get maxDaysFuture(): number | undefined {
        return this.componentData?.config.maxDaysFuture;
    }


    constructor(
        public readonly contextService: ContextInteractionService
    ) {
        super(contextService);
    }

	ngOnInit() {
        super.ngOnInit();
		const storedValue = this.getContextValue();
        if (storedValue) {
			this.dateModel = new Date(storedValue);
			if (this.formGroup != null) {
				let ctrl = this.formGroup.get(this.componentData.key);
				if (ctrl != null) {
					ctrl.setValue(this.dateModel);
				}
			}
        }
    }

	dateChanged(e: Date): void {
        let formattedDate = (e != null) ? e.toISOString() : "";//yyyy-MM-ddTHH:mm:ssZ
        this.setContextValue(formattedDate);
        if (this.formGroup != null) {
            let ctrl = this.formGroup.get(this.componentData.key);
            if (ctrl != null) {
                ctrl.setValue(formattedDate);
            }
        }
        super.change();
    }


}
